<script setup lang="ts">
    import type { CatStackValue } from '@/views/dicoms/ctScan/types';

    const props = defineProps<{
        value: CatStackValue;
    }>();

    const onUpdateSlider = (value: number) => {
        // eslint-disable-next-line vue/no-mutating-props
        props.value.currentIndex = value;
    };
</script>

<template>
    <v-slider
        :model-value="value.currentIndex"
        :thumb-size="24"
        min="0"
        color="blue"
        step="1"
        :max="value && value.count ? value.count - 1 : 0"
        thumb-label="always"
        label="Adjust plane"
        @update:model-value="onUpdateSlider"
    />
</template>
